/* KLB: pinned mobile add-to-cart bar. Mirrors the main product form; clicking it clicks the main button. */
if (!customElements.get('klb-sticky-atc')) {
  customElements.define(
    'klb-sticky-atc',
    class KlbStickyAtc extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.klb-satc__btn');
        this.labelEl = this.querySelector('.klb-satc__label');
        this.variantEl = this.querySelector('.klb-satc__variant');
        this.priceEl = this.querySelector('.klb-satc__price');
        this.mq = window.matchMedia('(max-width: 749px)');
        this.past = false;
        this.raf = null;
        this.schedule = () => {
          if (this.raf) return;
          this.raf = requestAnimationFrame(() => {
            this.raf = null;
            this.sync();
          });
        };
        this.onMq = () => this.update();
        this.ticking = false;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.checkPast();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.onClick = this.onClick.bind(this);
        this.btn.addEventListener('click', this.onClick);
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
        else this.mq.addListener(this.onMq);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.bind();
            this.schedule();
          });
        }
        this.bind();
      }

      disconnectedCallback() {
        this.btn && this.btn.removeEventListener('click', this.onClick);
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        else this.mq.removeListener(this.onMq);
        this.unsubVariant && this.unsubVariant();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.mo && this.mo.disconnect();
        document.body.classList.remove('klb-satc-on');
      }

      getInfo() {
        return document.querySelector('product-info[id^="MainProduct-"]');
      }

      bind() {
        const info = this.getInfo();
        const main = info && info.querySelector('product-form button[name="add"]');
        if (main === this.main) return;
        this.main = main;
        this.mo && this.mo.disconnect();
        this.checkPast();
        if (!main) return;
        this.mo = new MutationObserver(this.schedule);
        this.mo.observe(main, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          characterData: true,
          subtree: true,
        });
        this.sync();
      }

      sync() {
        const info = this.getInfo();
        const main = this.main;
        if (!info || !main) return;

        // Button state mirrors the main button (Add to cart / Sold out / Unavailable).
        const loading = main.classList.contains('loading');
        const disabled = main.disabled || (main.getAttribute('aria-disabled') === 'true' && !loading);
        const mainLabel = main.querySelector(':scope > span:not(.hidden)');
        const text = mainLabel ? mainLabel.textContent.trim() : '';
        if (text && this.labelEl.textContent !== text) this.labelEl.textContent = text;
        this.btn.disabled = disabled;
        if (loading) this.btn.setAttribute('aria-busy', 'true');
        else this.btn.removeAttribute('aria-busy');

        // Selected variant / shade.
        const json = info.querySelector('variant-selects [data-selected-variant]');
        if (json && this.variantEl) {
          try {
            const v = JSON.parse(json.textContent);
            if (v && v.title) this.variantEl.textContent = v.title;
          } catch (e) {}
        }

        // Price: read what the main price block shows (handles sale prices).
        const price = info.querySelector('[id^="price-"] .price');
        if (price && this.priceEl) {
          const sale = price.classList.contains('price--on-sale');
          const el = sale
            ? price.querySelector('.price__sale .price-item--last')
            : price.querySelector('.price__regular .price-item--regular');
          const p = el && el.textContent.trim();
          if (p) this.priceEl.textContent = p;
        }
      }

      // Show only once the main button has scrolled ABOVE the viewport.
      // (A rAF-throttled passive scroll check also catches fast flings/jumps that skip past the button.)
      checkPast() {
        const r = this.main && this.main.getBoundingClientRect();
        const past = !!r && r.height > 0 && r.bottom < 0;
        if (past !== this.past) {
          this.past = past;
          this.update();
        }
      }

      update() {
        const show = this.mq.matches && this.past;
        this.classList.toggle('is-visible', show);
        if (show) {
          this.removeAttribute('aria-hidden');
          this.removeAttribute('inert');
        } else {
          this.setAttribute('aria-hidden', 'true');
          this.setAttribute('inert', '');
        }
        document.body.classList.toggle('klb-satc-on', show);
      }

      onClick() {
        const main = this.main;
        if (!main || main.disabled || main.getAttribute('aria-disabled') === 'true') return;
        main.click();
      }
    }
  );
}
